export const Width = {
  SM: 576,
  MD: 768,
  XL: 1200,
  XXL: 1400,
};

export const Padding = {
  SM: 20,
  MD: 30,
  XL: 90,
  XXL: 150,
};
